import { ButtonStyled } from "../Button/styles";
import { ImageCarousel } from "../ImageCarousel/ImageCarousel";
import { RoundButton } from "../../assets/styles/RoudeButton";
import { formatDate } from "../../utils/formatDate";

import commentIcon from "../../assets/imgs/comment_icon.svg";
import scissor from "../../assets/imgs/scissor.svg";
import coroa from "../../assets/imgs/coroa.svg";
import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../providers/UserContext";
import { PostContext } from "../../providers/PostContext";
import { StyledPost } from "./styles";

import { Link } from "react-router-dom";
import { CommentModal } from "../Feed/components/Modals/CommentModal/CommentModal";

type iUser = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  username: string;
  icon: string;
  role: "user" | "admin";
  phone: string;
  email: string;
  password: string;
  deletedAt: Date | null;
  bio?: string;
  image?: string;
};

type iPostImageUser = {
  id: number;
  message: string;
  like: number;
  dislike: number;
  comment: number;
  Images: {
    id: number;
    createdAt: Date;
    publicId: string;
    url: string;
    secureUrl: string;
  }[];
  User: iUser;
  createdAt: Date;
  updatedAt: Date;
};

export const Post = ({
  post,
  postIdClicked,
}: {
  post: iPostImageUser;
  postIdClicked?: number;
}) => {
  const { followUser, unfollowUser, user, checkIfUserFollow } =
    useContext(UserContext);
  const { likePost, getTypeLikePost } = useContext(PostContext);

  const [showComments, setShowComments] = useState(false),
    [shouldScroll, setShouldScroll] = useState(true);

  const postId = useRef<number | null>(null);

  const [isFollowing, setIsFollowing] = useState(false),
    [like, setLike] = useState(0),
    [dislike, setDislike] = useState(0),
    [typee, setType] = useState<string | void>();

  useEffect(() => {
    setLike(post.like);
    setDislike(post.dislike);

    if (user) {
      const feachDataTypeLike = async () => {
        const response = await getTypeLikePost(post.id);
        setType(response);
      };

      feachDataTypeLike();
    }
  }, []);

  const handleLikeDislike = async (
    postId: number,
    type: "like" | "dislike"
  ) => {
    try {
      if (type === "like") {
        setLike((prevLike) => prevLike + 1); // Incrementa o número de like
        if (typee) {
          setDislike((prevDislike) => prevDislike - 1);
        }
      } else if (type === "dislike") {
        setDislike((prevDislike) => prevDislike + 1); // Incrementa o número de like
        if (typee) {
          setLike((prevLike) => prevLike - 1);
        }
      }

      setType(type);

      likePost(postId, type);
      getTypeLikePost(post.id);

      // Atualizar o estado dos posts após a interação, se necessário
    } catch (error) {
      console.error(
        `Erro ao ${type === "like" ? "curtir" : "dar dislike"} no post:`,
        error
      );
    }
  };
  useEffect(() => {
    const verifyIsFollow = async () => {
      if (user) {
        const isFollow = await checkIfUserFollow({
          followerId: post.User.id,
          userId: user.id,
        });
        setIsFollowing(isFollow ? true : false);
      }
    };
    verifyIsFollow();
  }, [checkIfUserFollow, post.User.id, user]);

  return (
    <StyledPost>
      <div
        className="post"
        key={post.id}
        ref={(ref) => {
          if (shouldScroll && post.id === postIdClicked && ref) {
            ref.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
            setShouldScroll(false);
          }
        }}
      >
        <div className="user-info">
          <div className="infos">
            <abbr title={`Perfil de ${post.User.username}`}>
              <Link to={`/perfil/${post.User.username}`}>
                <img src={post.User.image} alt={post.User.username} />
              </Link>
            </abbr>
            <div>
              <h3 className="info-name">{post.User.name}</h3>
              <h4 className="info-username">
                <img src={post.User.icon} alt="icon" />
                {post.User.username}
              </h4>
              <small className="info-posted-at">
                {formatDate(post.createdAt)}
              </small>
            </div>
          </div>
          {user && user.id !== post.User.id && (
            <abbr title={isFollowing ? "Desseguir" : "Seguir"}>
              <ButtonStyled
                onClick={() => {
                  isFollowing
                    ? unfollowUser(post.User.id)
                    : followUser(post.User.id);
                }}
              >
                {isFollowing ? "Desseguir" : "Seguir"}
              </ButtonStyled>
            </abbr>
          )}
        </div>
        <div className="post-body">
          <div className="message">{post.message}</div>
          <div className="images">
            {!!post.Images.length && <ImageCarousel images={post.Images} />}
            <div className="text">
              {like} <span>Likes</span> {dislike} <span>Tesouradas</span>{" "}
              {post.comment} <span>Bodejos</span>
            </div>
          </div>
        </div>
        <div className="interact">
          <abbr title="Coroada">
            <RoundButton
              onClick={() => handleLikeDislike(post.id, "like")}
              disabled={!user || typee === "like"}
            >
              <img src={coroa} alt="like" />
            </RoundButton>
          </abbr>
          <abbr title="Tesourada">
            <RoundButton
              onClick={() => handleLikeDislike(post.id, "dislike")}
              disabled={!user || typee === "dislike"}
            >
              <img src={scissor} alt="dislike" />
            </RoundButton>
          </abbr>
          <abbr title="Comentários">
            <RoundButton
              onClick={() => {
                if (setShowComments) {
                  setShowComments(true);
                }
                postId.current = post.id;
              }}
            >
              <img src={commentIcon} alt="Comentário" />
            </RoundButton>
          </abbr>
        </div>
      </div>
      {showComments && (
        <CommentModal
          postId={postId.current}
          setShowComments={setShowComments}
        />
      )}
    </StyledPost>
  );
};
